module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("new_notice", [["div",{"class":"gui-notice-item &&0&&","notice-alias":""},[["p",{"class":"message"},[["textNode",{"text":" "}],["span",{},[],[["message","__text",true,[{"name":"html","params":[]}]]]],["textNode",{"text":" "}]]]],[["type","class"],["alias","notice-alias",true]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/common/notice.tpl
// module id = 173
// module chunks = 5